import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            // Fragment navigation (e.g. /#compare): scroll to the target once
            // the destination page has painted. BrowserRouter performs no
            // native fragment scroll, so we do it ourselves.
            const id = location.hash.slice(1);
            const raf = window.requestAnimationFrame(() => {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                } else {
                    window.scrollTo(0, 0);
                }
            });
            return () => window.cancelAnimationFrame(raf);
        }
        window.scrollTo(0, 0);
        return undefined;
    }, [location.pathname, location.hash, location.key]);

    return null;
}
